<template>
<div class="shareCommon4_ui">
    <div class="share-dialog-main" ref="poster">
        <div class="download-wrap">

            <div class="main-img-wrap">
                <img class="main-img" :src="shareConfig.mainPicUrl+'?imageView2/1/w/650/h/812/q80/format/webp'" />

            </div>
            <div class="main-info">
                <div class="title" id="title-box">
                    <div id="title">
                        {{shareConfig.info1.name}}
                    </div>

                </div>

                <div class="time-box">
                    <div class="time">活动时间：{{shareConfig.info1.time}}</div>
                </div>
                <div class="info-container">
                    <div class="qrcode-wrap">
                        <div class="qrcode" id="qrcode">
                          <img :src="qrCode" v-if="qrCode">
                        </div>
                    </div>
                    <div class="info-main">
                        <div class="tl-name">{{shareConfig.info1.title}}</div>
                        <div class="desc">
                            {{shareConfig.info1.activityTitle}}
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
    <transition name="slide-fade">
        <div class="poster-box" v-show="isPoster&&posterImg!=''">
            <div class="posterImg">
                <div class="close" @click="closePoster()">
                    <i class="iconfont iconcha"></i>
                </div>
                <img :src="posterImg" />
            </div>
        </div>
    </transition>
</div>
</template>

<script>
var config = {};
import api from "@/utils/api";
import {
    jAlert3
} from "@/base/jAlert/jAlert";
import QRCode from "qrcodejs2";
import html2canvas from "html2canvas";
import {
    getStorage
} from "@/utils/wxuser";
import { miniProgram } from "@/utils/miniProgram";
export default {
    data() {
        return {
            wxuser: getStorage("wxuser"),
            qrCode: "",
            posterImg: "",
            isPoster: false,
        };
    },
    props: {
        shareConfig: {
            type: Object,
        },
        hasConfigSKU: {
            type: Boolean,
        },
    },
    watch: {
        isPoster(val) {
            if (this.posterImg == "" && val) {
                this.$store.dispatch("openLoading", "加载中...");
            }
        },
    },
    methods: {
        closePoster() {
            this.isPoster = false;
            // this.$emit("close");
        },
        shotPic() {
            html2canvas(this.$refs.poster, {
                useCORS: true,
                // allowTaint: true
            }).then((canvas) => {
                // document.body.appendChild(canvas);
                this.$nextTick(() => {
                    let dataURL = canvas.toDataURL("image/png");
                    this.posterImg = dataURL;
                    this.$store.dispatch("closeLoading");
                });
            });
        },
        ellipsis() {
            var $container = document.getElementById("title-box");
            var $content = document.getElementById("title");
            var str = $content.innerHTML;
            console.log($content.offsetHeight, $container.offsetHeight)
            if ($content.offsetHeight >= $container.offsetHeight) {
                for (var i = 0; i <= str.length; i++) {
                    $content.innerHTML = str.slice(0, i)
                    if ($content.offsetHeight > $container.offsetHeight) {

                        $content.innerHTML = str.slice(0, i - 4) + "..."
                        console.log($content.innerHTML)
                        break;
                    }
                }
            }
        },
        async getShortUrl() {
            var opt = {
                longUrl: this.shareConfig.url,
                appid: config.appid,
                componentAppid: config.componentAppid,
            };
            // this.$store.dispatch("openLoading", "加载中...");
            var codeW = 80;
            var res = await api.getShortUrl(opt)
            if (res.result == 1) {
                var isMiniProgram = await miniProgram.isMiniProgram();
                if (isMiniProgram) {
                    var obj = {
                        hotelCode: config.hotelCode,
                        hotelGroupCode: config.hotelGroupCode,
                        scene: res.retVal,
                        appid: config.miniAppid,
                        componentAppid: config.componentAppid,
                        line_color_g: 0,
                        page: 'pages/mall/webview',
                        width: 500,
                        line_color_b: 0,
                        auto_color: false,
                        is_hyaline: true,
                        line_color_r: 0,
                    }
                    api.getWxacodeUnlimitUrl(obj).then(res => {
                        this.qrCode = res.retVal.imageUrl + '?imageMogr2/thumbnail/150x'
                        this.$nextTick(() => {
                            this.shotPic();
                        })
                    })
                } else {
                    this.$nextTick(() => {
                        let qrcode = new QRCode("qrcode", {
                            width: codeW,
                            height: codeW,
                            text: res.retVal, // 二维码地址
                        });
                        this.shotPic();
                    });
                }

            } else {
                this.$nextTick(() => {
                    let qrcode = new QRCode("qrcode", {
                        width: codeW,
                        height: codeW,
                        text: this.shareConfig.url, // 二维码地址
                    });
                    this.shotPic();
                });
                this.$store.dispatch("closeLoading");
            }

        },
    },

    created() {

        config = getStorage("config");
    },
    mounted() {
        this.$nextTick(() => {
            this.ellipsis();
        })

        this.getShortUrl();
    },
};
</script>

<style lang="less">
@import url("~@/styles/base.less");
@import url("~@/styles/mixin.less");

.shareCommon4_ui {
    width: 100%;
    overflow: hidden;

    .share-dialog-main {
        position: fixed;
        width: 10rem;
        background: #fff;
        overflow: hidden;
        box-sizing: border-box;
        left: 0;
        top: -100000px;
        z-index: -9;
        padding: 0.8rem 0.666667rem;

        .download-wrap {
            width: 100%;
            box-shadow: 0px 2px 15px 0px rgba(0, 0, 0, 0.15);
            border-radius: 20px;
            overflow: hidden;
        }

        .main-img-wrap {
            .main-img {
                width: 100%;
                height: 10.826667rem;
            }
        }

        .main-info {
            position: relative;
            z-index: 2;
            margin-top: -0.533333rem;
            border-radius: 0.533333rem;
            padding: 0.533333rem;
            border: 1px solid #3691ff;
            background: #fff;

            .title {
                font-family: PingFangSC-Semibold;
                font-size: 18px;
                color: #333333;
                line-height: 1.4;
                text-align: center;
            }

            .tl-name {
                font-family: PingFangSC-Regular;
                font-size: 12px;
                color: #333333;
                line-height: 1.4;
                text-align: center;
            }

            .time-box {
                width: 100%;
                margin-top: 0.666667rem;
                font-family: PingFangSC-Regular;
                font-size: 12px;
                color: #333333;
                line-height: 0.8rem;
                background: #f6f6f6;
                border-radius: 16px;
                text-align: center;
            }

            .info-container {
                display: flex;
                margin-top: 0.533333rem;
                 .qrcode-wrap {
                    box-sizing: border-box;
                    text-align: center;
                    padding-right: 0.266667rem;

                    .qrcode {
                        display: inline-block;
                        width: 2.133333rem;
                        height: 2.133333rem;
                        box-sizing: border-box;
                        img{
                            width: 100%;
                            height: 100%;
                        }
                    }
                }
                .info-main {
                    flex: 1;
                    padding-left: 0.32rem;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;

                    .tl-name {
                        font-size: 13px;
                        color: #333333;
                        font-family: PingFangSC-Medium;
                        line-height: 1.4;
                        padding-bottom: 0.213333rem;
                        text-align: left;
                    }

                    .desc {
                        border-top: 1px solid #F1F1F5;
                        font-family: PingFangSC-Regular;
                        font-size: 12px;
                        line-height: 1.4;
                        padding-top: 0.213333rem;
                        color: #333333;
                    }
                }
            }
        }
    }

    .poster-box {
        z-index: 999;
        background: rgba(0, 0, 0, 0.5);
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        height: 100vh;

        .posterImg {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);

            img {
                width: 75vw;
            }

            .close {
                color: #fff;
                width: 0.8rem;
                height: 0.8rem;
                background: rgba(0, 0, 0, 0.5);
                position: absolute;
                right: 0;
                top: 0;
                margin-right: -0.4rem;
                margin-top: -0.4rem;
                display: flex;
                justify-content: center;
                align-items: center;
                border-radius: 50%;

                i {
                    font-size: 14px;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/shareCommon4.vue